import DS from 'ember-data';
import { inject as service } from '@ember/service';
import Transition from '@ember/routing/-private/transition';
import RouterService from '@ember/routing/router-service';
import Route from 'cio/routes/base';
import TransactionalMessageModel from 'cio/models/transactional-message';

export default class TransactionalMessageRoute extends Route {
  @service store!: DS.Store;
  @service router!: RouterService;

  model(params: { transactional_message_id: string }) {
    return this.store.findRecord('transactional-message', params.transactional_message_id);
  }

  // After adding multi-language support for transactional messages, we have multiple templates
  // belonging to a message. Having a template ID in the route matches newsletters' route pattern.
  redirect(model: TransactionalMessageModel, transition: Transition) {
    if (transition.to.name === `${this.fullRouteName}.index`) {
      this.router.transitionTo(`${this.fullRouteName}.template`, model.id, model.belongsTo('template').id());
    }
  }
}
